import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';

export class CustomerReportCreateDto extends BaseModel {

  @Expose()
  name!: string;
}

export class CustomerReportUpdateDto extends BaseModel {

  @Expose()
  name!: string;
}
